import { createFileRoute } from '@tanstack/react-router';
import { HealthPhasesScreen } from '../../screens/health/HealthPhases';

export const Route = createFileRoute('/health/phases')({
  component: HealthPhasesScreen,
});
